$(document).ready(function() {
    // Menu
    $(document).on('click', '#openNav', function(e) {
      e.preventDefault();
      $('#navLinks').slideToggle(400, function() {
        $('#navLinks').css('display', '').toggleClass('is-visible');
      });
    });

    $(document).on('scroll', function(e) {
    });
  });